import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-clipboard",
  "use": "foquz-icon-clipboard-usage",
  "viewBox": "0 0 18 21",
  "content": "<symbol viewBox=\"0 0 18 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-clipboard\"><path d=\"M13 3h2a2 2 0 012 2v13a2 2 0 01-2 2H3a2 2 0 01-2-2V5a2 2 0 012-2h2m1-2h6a1 1 0 011 1v2a1 1 0 01-1 1H6a1 1 0 01-1-1V2a1 1 0 011-1z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol